import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';
import { MaterialModule } from '@sdbn/appclient';
import { NumberPlateInputComponent } from './numberplate-input.component';

@NgModule({
  declarations: [
    NumberPlateInputComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonTranslationModule
  ],
  exports: [
    NumberPlateInputComponent
  ]
})
export class NumberplateInputModule { }
